/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_ZH_TW: Record<string, string> = {
    ariaAnnounceChart: '圖表，${seriesCount}[number] 個系列',
    ariaAnnounceFlowProportionLink: '連結 ${index} / ${count}，從 ${from} 到 ${to}，${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: '節點 ${index} 之 ${count}, ${description}',
    ariaAnnounceGaugeChart: '儀表板圖表, ${caption}',
    ariaAnnounceHierarchyChart: '階層圖表, ${caption}',
    ariaAnnounceHierarchyDatum: '層級 ${level}[number]，${count}[number] 個子項目，${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: '按空格鍵或回車鍵切換可見性',
    ariaLabelAddHorizontalLine: '添加水平線條',
    ariaLabelAnnotationOptionsToolbar: '註解選項',
    ariaLabelAnnotationSettingsDialog: '註解設定',
    ariaLabelColorPicker: '顏色選擇器',
    ariaLabelFinancialCharts: '財務圖表',
    ariaLabelLegend: '圖例',
    ariaLabelLegendItem: '${label}, 圖例項目 ${index}[number]，總共 ${count}[number]',
    ariaLabelLegendItemUnknown: '未知的圖例項目',
    ariaLabelLegendPageNext: '下一頁圖例',
    ariaLabelLegendPagePrevious: '前一圖例頁面',
    ariaLabelLegendPagination: '圖例分頁',
    ariaLabelNavigator: '導航器',
    ariaLabelNavigatorMaximum: '最大值',
    ariaLabelNavigatorMinimum: '最小',
    ariaLabelNavigatorRange: '範圍',
    ariaLabelRangesToolbar: '範圍',
    ariaLabelSettingsTabBar: '設定',
    ariaLabelZoomToolbar: '縮放',
    ariaValuePanRange: '${min}[percent0to2dp] 到 ${max}[percent0to2dp]',
    contextMenuDownload: '下载',
    contextMenuPanToCursor: '平移到此處',
    contextMenuToggleOtherSeries: '切換其他系列',
    contextMenuToggleSeriesVisibility: '切換可見性',
    contextMenuZoomToCursor: '縮放至此',
    dialogHeaderChannel: '頻道',
    dialogHeaderDatePriceRange: '日期和價格',
    dialogHeaderDateRange: '日期範圍',
    dialogHeaderFibonacciRange: '斐波那契回撤',
    dialogHeaderLine: '線條',
    dialogHeaderPriceRange: '價格範圍',
    dialogHeaderText: '文字',
    dialogInputAlign: '對齊',
    dialogInputColorPicker: '顏色',
    dialogInputColorPickerAltText: '文字顏色',
    dialogInputExtendAbove: '向上擴展',
    dialogInputExtendBelow: '擴展至下方',
    dialogInputExtendChannelEnd: '延伸通道末端',
    dialogInputExtendChannelStart: '延伸通道起點',
    dialogInputExtendLeft: '向左延伸',
    dialogInputExtendLineEnd: '延伸線段末端',
    dialogInputExtendLineStart: '延伸線條起點',
    dialogInputExtendRight: '延伸至右邊',
    dialogInputFibonacciBands: '頻帶',
    dialogInputFibonacciBandsAltText: '斐波那契頻帶',
    dialogInputFillColorPicker: '填充',
    dialogInputFillColorPickerAltText: '填充顏色',
    dialogInputFontSize: '大小',
    dialogInputFontSizeAltText: '字體大小',
    dialogInputLineStyle: '虛線',
    dialogInputPosition: '位置',
    dialogInputReverse: '反向',
    dialogInputShowFill: '顯示填充',
    dialogInputStrokeWidth: '粗細',
    dialogInputStrokeWidthAltText: '線條粗細',
    iconAltTextAlignCenter: '置中',
    iconAltTextAlignLeft: '左',
    iconAltTextAlignRight: '右',
    iconAltTextClose: '關閉',
    iconAltTextLineStyleDashed: '長虛線',
    iconAltTextLineStyleDotted: '短虛線',
    iconAltTextLineStyleSolid: '實線',
    iconAltTextPositionBottom: '底部',
    iconAltTextPositionCenter: '中心',
    iconAltTextPositionTop: '頂端',
    inputTextareaPlaceholder: '添加文字',
    measurerDateRangeBars: '${value}[number] 根條',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: '體積 ${value}',
    overlayLoadingData: '正在載入數據...',
    overlayNoData: '沒有資料可顯示',
    overlayNoVisibleSeries: '沒有可見的系列',
    overlayUnsupportedBrowser: '瀏覽器版本不相容。請升級您的瀏覽器。',
    seriesHistogramTooltipCount: '${yName} (計數)',
    seriesHistogramTooltipFrequency: '頻率',
    seriesHistogramTooltipMean: '${yName} (平均值)',
    seriesHistogramTooltipSum: '${yName} (總和)',
    toolbarAnnotationsArrow: '箭頭',
    toolbarAnnotationsArrowDown: '下箭頭',
    toolbarAnnotationsArrowUp: '向上箭頭',
    toolbarAnnotationsCallout: '注釋',
    toolbarAnnotationsClearAll: '全部清除',
    toolbarAnnotationsComment: '註解',
    toolbarAnnotationsDatePriceRange: '日期和價格',
    toolbarAnnotationsDateRange: '日期範圍',
    toolbarAnnotationsDelete: '刪除',
    toolbarAnnotationsDisjointChannel: '非連續通道',
    toolbarAnnotationsDragHandle: '工具欄拖曳',
    toolbarAnnotationsFibonacciAnnotations: '斐波那契',
    toolbarAnnotationsFibonacciRetracement: '斐波那契回撤',
    toolbarAnnotationsFibonacciRetracementTrendBased: '斐波那契趨勢基線',
    toolbarAnnotationsFillColor: '填充顏色',
    toolbarAnnotationsHorizontalLine: '水平線',
    toolbarAnnotationsLineAnnotations: '趨勢線',
    toolbarAnnotationsLineColor: '線條顏色',
    toolbarAnnotationsLineStrokeWidth: '線條粗細',
    toolbarAnnotationsLineStyle: '線條樣式',
    toolbarAnnotationsLock: '鎖定',
    toolbarAnnotationsMeasurerAnnotations: '測量工具',
    toolbarAnnotationsNote: '註解',
    toolbarAnnotationsParallelChannel: '平行通道',
    toolbarAnnotationsPriceRange: '價格範圍',
    toolbarAnnotationsQuickDatePriceRange: '測量',
    toolbarAnnotationsSettings: '設定',
    toolbarAnnotationsShapeAnnotations: '箭頭',
    toolbarAnnotationsText: '文字',
    toolbarAnnotationsTextAnnotations: '文字註解',
    toolbarAnnotationsTextColor: '文字顏色',
    toolbarAnnotationsTextSize: '文字大小',
    toolbarAnnotationsTrendLine: '趨勢線',
    toolbarAnnotationsUnlock: '解鎖',
    toolbarAnnotationsVerticalLine: '垂直線',
    toolbarRange1Month: '1月',
    toolbarRange1MonthAria: '1個月',
    toolbarRange1Year: '1年',
    toolbarRange1YearAria: '1年',
    toolbarRange3Months: '3個月',
    toolbarRange3MonthsAria: '3個月',
    toolbarRange6Months: '6個月',
    toolbarRange6MonthsAria: '6個月',
    toolbarRangeAll: '全部',
    toolbarRangeAllAria: '全部',
    toolbarRangeYearToDate: '年初至今',
    toolbarRangeYearToDateAria: '今年迄今',
    toolbarSeriesTypeCandles: '蠟燭圖',
    toolbarSeriesTypeDropdown: '圖表類型',
    toolbarSeriesTypeHighLow: '高低',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: '空心蠟燭',
    toolbarSeriesTypeLine: '折線圖',
    toolbarSeriesTypeLineWithMarkers: '帶標記的折線圖',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: '階梯線',
    toolbarZoomPanEnd: '移動到結尾',
    toolbarZoomPanLeft: '向左平移',
    toolbarZoomPanRight: '向右平移',
    toolbarZoomPanStart: '移動到起點',
    toolbarZoomReset: '重設縮放',
    toolbarZoomZoomIn: '放大',
    toolbarZoomZoomOut: '縮小',
    tooltipPaginationStatus: '${index}[number]中的${count}[number]',
};
